import React from "react";
import ListingPage from "./ListingPage";
import ListingPageV2 from "./v2/ListingPage";
import { useIsNewLayout } from "../../services/SettingsContext";

export default function ListingPageSwitcher() {
  return useIsNewLayout() ? <ListingPageV2 /> : <ListingPage />;
}
